import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { RulesSection } from './RulesSection';
import { OfferSection } from './OfferSection';
import { FaqSection } from './FaqSection';
import { FinalCtaSection } from './FinalCtaSection';
import { SectionDivider } from './ui/SectionDivider';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-brand-bg text-brand-text selection:bg-brand-gold selection:text-brand-bg" data-id="element-294">
      <HeroSection data-id="element-295" />
      <SectionDivider data-id="element-296" />

      <PainSection data-id="element-297" />
      <SectionDivider data-id="element-298" />

      <RulesSection data-id="element-299" />
      <SectionDivider data-id="element-300" />

      <OfferSection data-id="element-301" />
      <SectionDivider data-id="element-302" />

      <FaqSection data-id="element-303" />
      <SectionDivider data-id="element-304" />

      <FinalCtaSection data-id="element-305" />
    </main>;
}